/** @format */
// 车辆类型（00：临停小车 01：临停大车 02：产权车 03：月卡车）
export enum AuthTypes {
  ParkSmall = '00',
  ParkBig = '01',
  PropertyCar = '02',
  MonthCar = '03',
  Visit = '05',
  Special = '04'
}

export const authTypesMap: {
  [key: string]: string;
} = {
  [AuthTypes.ParkSmall]: '临停小车',
  [AuthTypes.ParkBig]: '临停大车',
  [AuthTypes.PropertyCar]: '产权车',
  [AuthTypes.MonthCar]: '月卡车',
  [AuthTypes.Visit]: '访客车',
  [AuthTypes.Special]: '特殊授权车辆'
};

// 车型 (00：小车，01：大车)-----经和后端核对  00是大车 01是小车
// 在场车辆的 是 (00：小车，01：大车) ，固定车辆管理 00是大车 01是小车
export enum CarTypes {
  CarSmall = '01',
  CarBig = '02'
}

export const carTypesMap: {
  [key: string]: string;
} = {
  [CarTypes.CarSmall]: '小型车',
  [CarTypes.CarBig]: '大型车'
};

// (00：小车，01：大车)
export enum enterCar {
  CarSmall = '01',
  CarBig = '02'
}
export const enterCarMap: {
  [key: string]: string;
} = {
  [CarTypes.CarSmall]: '小型车',
  [CarTypes.CarBig]: '大型车'
};

// 是否优惠，（00：否，01：是）
export enum DiscountStatus {
  Yes = '01',
  No = '00'
}

export const discountStatusMap: {
  [key: string]: string;
} = {
  [DiscountStatus.Yes]: '是',
  [DiscountStatus.No]: '否'
};

// 是否免费，（00：否，01：是）
export enum FreeStatus {
  Yes = '01',
  No = '00'
}

export const freeStatusMap: {
  [key: string]: string;
} = {
  [FreeStatus.Yes]: '是',
  [FreeStatus.No]: '否'
};

// 出场方式，02：自动放行，00：确认放行，01：收费放行，05：跟车出场，04：清理出场，03：特殊放行，06：被冲出场，07：手动抬杆
export enum ExitEvents {
  ReleaseAuto = '02',
  ReleaseRight = '00',
  Releasecharge = '01',
  AppearanceAs = '05',
  AppearanceClean = '04',
  ReleaseSpecial = '03',
  AppearanceBlunt = '06',
  ManualWrangle = '07'
}
export const exitEventsMap: {
  [key: string]: string;
} = {
  [ExitEvents.ReleaseAuto]: '自动放行',
  [ExitEvents.ReleaseRight]: '确认放行',
  [ExitEvents.Releasecharge]: '收费放行',
  [ExitEvents.AppearanceAs]: '跟车出场',
  [ExitEvents.AppearanceClean]: '清理出场',
  [ExitEvents.ReleaseSpecial]: '特殊放行',
  [ExitEvents.AppearanceBlunt]: '被冲出场',
  [ExitEvents.ManualWrangle]: '手动抬杆'
};
// 下发状态，(00：下发中 ，01：下发成功，02下发失败，03：无需下发)

export enum IssuedStatus {
  IssuedLoad = '00',
  IssuedSuceess = '01',
  IssuedFail = '02',
  IssuedDont = '03'
}

export const issuedStatusMap: {
  [key: string]: string;
} = {
  [IssuedStatus.IssuedLoad]: '下发失败',
  [IssuedStatus.IssuedSuceess]: '下发成功',
  [IssuedStatus.IssuedFail]: '下发中',
  [IssuedStatus.IssuedDont]: '无需下发'

  // [IssuedStatus.IssuedLoad]: '下发中',
  // [IssuedStatus.IssuedSuceess]: '下发成功',
  // [IssuedStatus.IssuedFail]: '下发失败',
  // [IssuedStatus.IssuedDont]: '无需下发',
};

// 支付方式，(00：现金，01：微信，02：支付宝，03：银联，04：ETC，05：优惠卷，06：积分)

export enum PayMethods {
  Cash = '00',
  WeChat = '01',
  Alipay = '02',
  UnionPay = '03',
  ETC = '04',
  Coupon = '05',
  Integral = '06'
}

export const payMethodsMap: {
  [key: string]: string;
} = {
  [PayMethods.Cash]: '现金',
  [PayMethods.WeChat]: '微信',
  [PayMethods.Alipay]: '支付宝',
  [PayMethods.UnionPay]: '银联',
  [PayMethods.ETC]: 'ETC',
  [PayMethods.Coupon]: '优惠券',
  [PayMethods.Integral]: '积分'
};

// 支付来源，00：出口岗亭，01：自助缴费机，02：移动岗亭，03：H5扫码，04：公众号，05：平台无感 06：第三方平台 07：第三方无感
export enum PaySources {
  Exit = '00',
  AutoPay = '01',
  Mobile = '02',
  H5 = '03',
  ThePublic = '04',
  Platform = '05',
  ThirdPartyPlatform = '06',
  NonInductive = '07'
}

export const paySourcesMap: {
  [key: string]: string;
} = {
  [PaySources.Exit]: '出口岗亭',
  [PaySources.AutoPay]: '自助缴费机',
  [PaySources.Mobile]: '移动岗亭',
  [PaySources.H5]: 'H5扫码',
  [PaySources.ThePublic]: '公众号',
  [PaySources.Platform]: '平台无感',
  [PaySources.ThirdPartyPlatform]: '第三方平台',
  [PaySources.NonInductive]: '第三方无感'
};

// 零钱状态， 00：待领取 01：已领取 02：已过期 03：无需找零
export enum ReceiveStatus {
  Unclaimed = '00',
  HaveReceived = '01',
  Expired = '02',
  NoNeed = '03'
}

export const receiveStatusMap: {
  [key: string]: string;
} = {
  [ReceiveStatus.Unclaimed]: '待领取',
  [ReceiveStatus.HaveReceived]: '已领取',
  [ReceiveStatus.Expired]: '已过期',
  [ReceiveStatus.NoNeed]: '无需找零'
};

// 车场业态， 00：酒店 01：商业 02：乐园03：其他
export enum ParkLotFormat {
  hotel = '00',
  trade = '01',
  amusement = '02',
  other = '03'
}

export const ParkLotFormatMap: {
  [key: string]: string;
} = {
  [ParkLotFormat.hotel]: '酒店',
  [ParkLotFormat.trade]: '商业',
  [ParkLotFormat.amusement]: '乐园',
  [ParkLotFormat.other]: '其他'
};
//发放渠道， 00：商家端 01：本地 02：C端应用 03：第三方
export enum distributionChannels {
  hotel = '00',
  trade = '01',
  amusement = '02',
  other = '03'
}

export const distributionChannelsMap: {
  [key: string]: string;
} = {
  [distributionChannels.hotel]: '商家端',
  [distributionChannels.trade]: '本地',
  [distributionChannels.amusement]: 'C端应用',
  [distributionChannels.other]: '第三方'
};
